import { AxiosResponse } from 'axios'

import type { ApiClient } from 'clients/yogi-api'
import { Group, Project, ProjectMetaType } from 'features/projects/types'

const PROJECT_LIST_URL = '/project/list'
const GROUP_PROJECT_LIST_URL = '/project/groups'
const PROJECT_META = '/project/meta'
const PROJECT_DELETE_URL = '/project'
const PROJECT_BULK_URL = '/project/bulk'

export type BulkUpdatePayload = {
  proj_uuids: string[]
  body: {
    usage?: string | null
    data_types?: string[] | null
    is_internal?: boolean
    archived?: boolean
  }
}

export class HomeService {
  constructor(private client: ApiClient) {}

  fetchProjects(): Promise<AxiosResponse<Project[]>> {
    return this.client.get(PROJECT_LIST_URL)
  }

  fetchProjectsBySearch(
    searchType: string,
    searchTerm: string,
  ): Promise<AxiosResponse<Project[]>> {
    return this.client.get(PROJECT_LIST_URL, {
      params: {
        search_type: searchType,
        search_term: searchTerm,
      },
    })
  }

  fetchGroupProjectsBySearch(): Promise<AxiosResponse<Group>> {
    return this.client.get(GROUP_PROJECT_LIST_URL)
  }

  fetchProjectsByGroup(proj_uuid: string): Promise<AxiosResponse<Group>> {
    return this.client.get(GROUP_PROJECT_LIST_URL, {
      params: {
        proj_uuid,
      },
    })
  }

  removeProject(proj_uuid: string): Promise<AxiosResponse<void>> {
    return this.client.delete(PROJECT_DELETE_URL, { params: { proj_uuid } })
  }

  getProjectMeta(): Promise<AxiosResponse<ProjectMetaType>> {
    return this.client.get(PROJECT_META)
  }

  bulkUpdateProjects(
    payload: BulkUpdatePayload,
  ): Promise<AxiosResponse<{ updated: number }>> {
    return this.client.patch(PROJECT_BULK_URL, {
      proj_uuids: payload.proj_uuids,
      body: payload.body,
    })
  }
}
